import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FormField,
  AutocompleteStyle,
  AutocompleteResultStyle,
  AutocompleteSearch,
} from "./styles";
import { Link, useHistory } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import { Modal, Button, Form } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import './styles.css'
import { db } from "../../services/firebase/Config";
import { ContactsOutlined } from "@material-ui/icons";
import axios from "axios";

export function Autocomplete(props) {
  const inputRef = useRef();
  const { query, setQuery, filteredItems, clearFilteredItems, loading } =
    props.useSearchItems();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const sesion = useSelector((state) => state.sesion);
  const urlLink = "https://pac.sysdent.net"
  // const urlLink = "http://localhost:5173"
  const endpoint = `${process.env.REACT_APP_API_URL}`
  // const endpoint = 'http://127.0.0.1:5001/sysdent-devs/us-central1'
  const { addToast } = useToasts();

  React.useEffect(()=>{
    inputRef.current.focus();
  }, [])
  //const { query, setQuery, filteredItems } = useMyHook(myitems);

  function handleClickItem(item) {
    clearFilteredItems();
    setQuery("");
    props.onSelected(item);
    //setQuery(`${item.nombres} ${item.apellidos}`);
  }

  function handleOpenModal() {
    setIsModalOpen(true);
  }

  function handleCloseModal() {
    setIsModalOpen(false);
  }

  function handleSavePhoneNumber() {
    if (phoneNumber.length !== 9 || !/^\d+$/.test(phoneNumber)) {
      alert("El número de teléfono debe tener 9 dígitos");
      return;
    }

    const urlToken = `${endpoint}/api/v1/pacientes/token?userid=${sesion.usuario.id}&empresaid=${sesion.usuario.empresaId}`;

    
    let razonSocial = "Sysdent";

      axios.get(urlToken)
      .then(response => {
      if (response.status !== 200) {
        alert(`Error al obtener el token: ${response.status}`);
        throw new Error(`Error al obtener el token: ${response.status}`);
      }

        const token = response.data.token;

        const url = `${urlLink}/invited?&empresaId=${sesion.usuario.empresaId}&token=${token}`;

        const mensaje = `¡Bienvenido a ${razonSocial}! Ingresa tus datos aquí: ${url}`;

        const whatsappLink = `https://wa.me/51${phoneNumber}?text=${encodeURIComponent(mensaje)}`;
        window.open(whatsappLink, '_blank');

        handleCloseModal();
      })
      .catch(error => {
        console.error(error);
      });
  }
  return (
    <>
      <AutocompleteStyle>
        <FormField
          ref={inputRef}
          type="text"
          placeholder="Buscar Paciente"
          onChange={(e) => setQuery(e.target.value)}
          value={query}
        ></FormField>

        <AutocompleteSearch>
          <AutocompleteResultStyle>
            {filteredItems.map((item) => (
              <li className="liStyle" key={item.id} onClick={() => handleClickItem(item)}>
                {props.toString(item)}
              </li>
            ))}
          </AutocompleteResultStyle>
        </AutocompleteSearch>
        <Tooltip
          placement="top"
          title="Agregar Paciente"
        // onClick={() => history.push("datos")}
        >
          {/* <EditIcon style={{ color: "#ffffff" }} /> */}
          <Link to="/paciente/datos">
            <img
              src={require("../../img/azul_nuevo_paciente.png")}
              alt="add new patient icon"
            />
          </Link>
        </Tooltip>
        <Tooltip
          placement="top"
          title="Invitar Paciente"
        >
          <span style={{ position: "relative", display: "inline-block" }}>
            <img
              src={require("../../img/mail-send.png")}
              alt="add new patient icon"
              onClick={handleOpenModal}
              style={{ cursor: "pointer" }}
            />
            {isModalOpen && (
              <div
                className="phone-input-panel"
                style={{
                  position: "absolute",
                  top: "110%",
                  right: 0,
                  background: "#fff",
                  border: "1px solid #ddd",
                  borderRadius: 8,
                  padding: 16,
                  marginTop: 4,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  maxWidth: 320,
                  zIndex: 1000,
                }}
              >
                <Form>
                  <Form.Group controlId="formPhoneNumber">
                    
                    <Form.Control
                      type="text"
                      placeholder="Teléfono"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      autoFocus
                    />
                  </Form.Group>
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 12 }}>
                    <Button variant="secondary" size="sm" onClick={handleCloseModal}>
                      Cancelar
                    </Button>
                    <Button variant="primary" size="sm" onClick={handleSavePhoneNumber}>
                      Enviar
                    </Button>
                  </div>
                </Form>
              </div>
            )}
          </span>
        </Tooltip>
      </AutocompleteStyle>
    </>
  );
}
